import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthProvider";
import './Landing.scss';
import Seo from "../components/Seo/Seo";
import NavBar from "../components/Home/NavBar";
import Header from "../components/Home/Header";
import Footer from "../components/Home/Footer";
import SubscriptionPlan from "../components/Home/SubscriptionPlan";
import FreeTrial from "../components/Home/FreeTrial";
import Features from "../components/Home/Features";
import ContactSection from "../components/Home/ContactSection";
import MissionSection from "../components/Home/MissionSection";
import MigrationSection from "../components/Home/MigrationSection";
import TrustSection from "../components/Home/TrustSection";
import BackToTop from "../components/Home/BackToTop";
import GDPRConsent from "../components/Home/GDPRConsent";
import ScheduleCallModal from "../components/Modal/ScheduleCallModal";
import PlatformsSection from "../components/Home/PlatformsSection";
import ProductSearchSection from "../components/Home/ProductSearchSection";
import ScrollReveal from "../components/Home/ScrollReveal";

const Landing = () => {
    const { t, i18n } = useTranslation();
    const { user, loading } = useAuth();
    const [showScheduleCallModal, setShowScheduleCallModal] = useState(false);
    const location = useLocation();

    // NavBar/Footer links to in-page sections (#features, #pricing, #trust)
    // navigate here via useSectionNav when clicked from another route — once
    // that lands, scroll to the target section.
    useEffect(() => {
        if (!location.hash) return;
        const id = location.hash.slice(1);
        const timeout = setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 0);
        return () => clearTimeout(timeout);
    }, [location.hash]);

    if (loading) return null;
    if (user) return <Navigate to="/dashboard" replace />;

    const scheduleCall = () => {
        setShowScheduleCallModal(true);
    };

    return (
        <div className="landing-page">
            <Seo title={t("landing.meta.title")} description={t("landing.header.sub").replace(/\*\*/g, "")} path={`/${i18n.language}`} />

            <NavBar/>

            <Header scheduleCall={scheduleCall} />

            <ScrollReveal><Features /></ScrollReveal>

            <ScrollReveal><PlatformsSection /></ScrollReveal>

            <ScrollReveal><SubscriptionPlan /></ScrollReveal>

            <ScrollReveal><ProductSearchSection /></ScrollReveal>

            <ScrollReveal><TrustSection /></ScrollReveal>

            <ScrollReveal><FreeTrial scheduleCall={scheduleCall} /></ScrollReveal>

            <Footer />

            <BackToTop />

            <GDPRConsent />

            <ScheduleCallModal
                show={showScheduleCallModal}
                onClose={() => {setShowScheduleCallModal(false)}}
            />
        </div>
    );
};

export default Landing;
